import { Money } from "@phosphor-icons/react";
import {
  Tooltip,
  TooltipAnchor,
  TooltipArrow,
  TooltipProvider,
} from "@replicate/ui";

export default function PriceTooltip({
  cost,
}: {
  cost: string;
}) {
  return (
    <TooltipProvider showTimeout={0}>
      <TooltipAnchor
        className={
          "underline decoration-dotted cursor-help text-r8-sm flex items-center gap-2"
        }
      >
        <Money size={16} />
        <span>~${cost} per run</span>
      </TooltipAnchor>
      <Tooltip className={"max-w-72 text-r8-xs z-50"}>
        <TooltipArrow />
        <p className="text-r8-sm">
          This model costs approximately{" "}
          <span className="font-semibold">${cost}</span> to run on Replicate,
          but this may vary depending on the model and your inputs.
        </p>
      </Tooltip>
    </TooltipProvider>
  );
}
